import { SyntheticEvent } from 'react'
import { GridFilterCellProps } from '@progress/kendo-react-grid'
import { SelectValue } from 'antd/es/select'
import { Option, Select } from 'components/Select'

import { OptionsProps } from './types'

type ItemProps = {
  id: string | number
  value: SelectValue
  label: string | number
}

type SelectFilterCellProps = {
  items: ItemProps[]
  defaultItemName?: string
  options?: OptionsProps
}

export const selectFilterCell =
  ({ items, defaultItemName = 'Select ...', options }: SelectFilterCellProps) =>
  (props: GridFilterCellProps): JSX.Element => (
    <SelectFilterCell
      {...props}
      items={items}
      defaultItemName={defaultItemName}
      options={options}
    />
  )

type SelectFilterCellComponentProps = {
  items: ItemProps[]
  defaultItemName: string
  options?: OptionsProps
} & GridFilterCellProps

const SelectFilterCell = (props: SelectFilterCellComponentProps) => {
  const getOperator = (event?: SelectValue) => {
    if (event) {
      return props?.options?.operator ? props.options.operator : 'eq'
    }
    return ''
  }

  const handleChange = (event: SelectValue) => {
    props.onChange({
      value: event ?? '',
      operator: getOperator(event),
      syntheticEvent: undefined as unknown as SyntheticEvent<unknown, Event>,
    })
  }

  return (
    <Select
      value={props.value}
      placeholder={props.defaultItemName}
      onChange={handleChange}
      showSearch
      allowClear
      style={{ width: '100%' }}
    >
      {props.items.map((item: ItemProps) => (
        <Option key={item.id} value={item.value}>
          {item.label}
        </Option>
      ))}
    </Select>
  )
}
